import styled from 'styled-components';

// CONSTANTS
import { RADICAL_RED, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  background-color: ${WHITE};
  padding: 20px 95px 20px 24px;
  border-radius: 8px;

  ${breakpoints.down('sm')} {
    flex-wrap: wrap;
  }

  ${breakpoints.down('xs')} {
    padding: 16px 38px 16px 16px;
  }

  .search-card {
    &__link {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
    }

    &__column-group {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      width: 50%;
      padding-right: 16px;

      &:last-child {
        padding-right: 0;
      }

      ${breakpoints.down('sm')} {
        width: 100%;
        padding-right: 0;
        padding-bottom: 8px;

        &:last-child {
          padding-bottom: 0;
        }
      }
    }

    &__column {
      padding-right: 16px;

      &:last-child {
        padding-right: 0;
      }
    }

    &__image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 168px;

      img {
        max-width: 100%;
        max-height: 96px;
      }

      ${breakpoints.down('sm')} {
        width: 126px;

        img {
          max-height: 72px;
        }
      }
    }

    &__link-more {
      position: relative;
      z-index: 1;
      cursor: default;
    }

    &__button {
      position: absolute;
      top: 50%;
      right: 16px;
      font-size: 42px;
      height: 58px;
      width: 58px;
      color: ${p => p.theme.palette.text.secondary};
      transform: translateY(-50%);
      padding: 0;
      z-index: 1;

      ${breakpoints.down('xs')} {
        right: 0;
        transform: translateY(-50%) rotate(90deg);
        width: 38px;
        height: 38px;
        font-size: 38px;
      }
    }
  }

  &.search-card {
    &-app {
    }

    &-channel {
    }

    &-show-movie {
    }

    &-channel,
    &-show-movie {
      .search-card__column-group {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        width: 50%;

        ${breakpoints.down('sm')} {
          padding-right: 16px;
          padding-bottom: 0;

          &:last-child {
            padding-right: 0;
          }
        }

        ${breakpoints.down('xs')} {
          width: 100%;
          padding-bottom: 8px;

          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    }
  }

  .search-card {
    &-app {
      &__image {
        margin-right: 16px;

        ${breakpoints.down('xs')} {
          margin-right: 0px;
        }
      }

      &__month-cost {
        padding: 0;
        font-size: 14px;
        line-height: 16px;
        color: ${p => p.theme.palette.text.secondary};
      }
    }

    &-channel {
      &__image {
        justify-content: center;

        img {
          width: auto;
          height: 100%;
        }
      }
    }

    &-show-movie {
      flex-wrap: nowrap;

      &__image {
        width: 71px;

        img {
          max-height: 106px;
        }
      }
    }

    &-content-crew {
      flex-wrap: nowrap;

      &__image {
        width: 71px;

        img {
          max-height: 106px;
        }
      }
    }
  }
`;

export const PriceContainer = styled.div`
  &.price-container,
  .price-container {
    display: flex;
    align-items: center;

    &__deal-container {
      display: inline-flex;
      flex-direction: column;
      transform: translate(0, 25%);

      .price-container__cost {
        margin-bottom: 0;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          right: -3px;
          left: -3px;
          top: 50%;
          transform: translate(0, -50%);
          height: 1px;
          background-color: ${RADICAL_RED};
        }
      }
    }

    &__deal-cost {
      font-weight: bold;
    }
  }
`;

export default Container;
